module.exports = __webpack_public_path__ + "mv.svg?a99b3a3eded0872f22f75e20216c2286";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/mv.svg
// module id = 1330
// module chunks = 27